export const PageRoutes = {
  HOME: "/",
  EARLY_BIRD_CAMPAIGN: "/campaign/early_bird",
  APP_LINKAGE_COUPON: "/app_linkage/aggregate",
  LOGIN: "/login",
  MY_PAGE: "/mypage",
  ORDER_HISTORY: "/order_history",
  USER_GUIDE: "/usage_guide",
  SHOP_LOCATION_SEARCH: "/shop_location_search",
  SHOP_SEARCH: "/shop_search/:type/:query",
  SHOP_SEARCH_2: "/shop_search/:type/:query1/:query2",
  MENU_LIST: "/menu_list/:storeCode/:date",
  ORDER_CONFIRMATION_DEFAULT: "/order_confirmation",
  ORDER_CONFIRMATION: "/order_confirmation/:storeCode/:date",
  ORDER_COMPLETE: "/order_complete/:orderId",
  ORDER_COMPLETE_DEFAULT: "/order_complete",
  TERM_OF_SERVICE: "/term_of_service",
  FAQ: "/faq",
  COMMERCIAL_LAW: "/commercial_law",
  PRIVACY_POLICY: "/privacy_policy",
  DEACTIVATE: "/deactivate",
  RESET_PASSWORD_MESSAGE: "/reset_password_msg",
  FORGOT_PASSWORD: "/forgot_password",
  REGISTRATION: "/registration/:key",
  REGISTRATION_DEFAULT: "/registration",
  REGISTRATION_MESSAGE: "/registration_message",
  MEMBERSHIP_INFO_SENT: "/membership_info_sent",
  RESET_PASSWORD: "/password/:key",
  RESET_PASSWORD_DEFAULT: "/password",
  CUSTOMER_INFO: "/customer_info",
  CUSTOMER_INFO_AUTH: "/customer_info_auth/:type/:value",
  CUSTOMER_INFO_CONFIRMATION: "/customer_info_confirmation",
  CUSTOMER_INFO_EDIT: "/customer_info_edit",
  EMAIL_EDIT: "/email_edit",
  CHANGE_EMAIL_MESSAGE: "/change_email_message",
  CHANGE_EMAIL: "/change_email/:key",
  CHANGE_EMAIL_DEFAULT: "/change_email",
  CHANGE_EMAIL_REGISTRATION_MESSAGE: "/change_email_registration_message",
  LEGAL_FOR_USE: "/legal_for_use",
  LEGAL_FOR_USE_QUERY: "/legal_for_use/:query",
  APP_COUPON: "/app_coupon",
  APP_LINKAGE: "/app_linkage",
  APP_COUPON_LIST: "/app_coupon_list",
};

export const EarlyBirdPageRoutesToCheck = [
  PageRoutes.HOME, // W-001
  PageRoutes.SHOP_SEARCH, // W-010
  PageRoutes.SHOP_SEARCH_2, // W-010
  PageRoutes.SHOP_LOCATION_SEARCH, // W-010
  PageRoutes.MENU_LIST, // W-013 , W-015
  PageRoutes.ORDER_CONFIRMATION, // W-042
];

export const InitialPages = [PageRoutes.HOME, PageRoutes.EARLY_BIRD_CAMPAIGN];
